// ----------------------------------------------------------------------
// <copyright file="Izenda.DashboardDesignerHeader.jsx" company="Izenda">
//  Copyright (c) 2015 Izenda, Inc.
//  ALL RIGHTS RESERVED
//
//  The entire contents of this file is protected by U.S. and
//  International Copyright Laws. Unauthorized reproduction,
//  reverse-engineering, and distribution of all or any portion of
//  the code contained in this file is strictly prohibited and may
//  result in severe civil and criminal penalties and will be
//  prosecuted to the maximum extent possible under the law.
//
//  RESTRICTIONS
//
//  THIS SOURCE CODE AND ALL RESULTING INTERMEDIATE FILES
//  ARE CONFIDENTIAL AND PROPRIETARY TRADE
//  SECRETS OF IZENDA INC. THE REGISTERED DEVELOPER IS
//  LICENSED TO DISTRIBUTE THE PRODUCT AND ALL ACCOMPANYING .NET
//  CONTROLS AS PART OF AN EXECUTABLE PROGRAM ONLY.
//
//  THE SOURCE CODE CONTAINED WITHIN THIS FILE AND ALL RELATED
//  FILES OR ANY PORTION OF ITS CONTENTS SHALL AT NO TIME BE
//  COPIED, TRANSFERRED, SOLD, DISTRIBUTED, OR OTHERWISE MADE
//  AVAILABLE TO OTHER INDIVIDUALS WITHOUT EXPRESS WRITTEN CONSENT
//  AND PERMISSION FROM IZENDA INC.
//
//  CONSULT THE END USER LICENSE AGREEMENT(EULA FOR INFORMATION ON
//  ADDITIONAL RESTRICTIONS.
//
//  </copyright>
// ----------------------------------------------------------------------

!(function() {
  var React = require('react');
  var GridLayout = require('share/components/controls/Izenda.GridLayout');
  var connect = require('share/enhancers/Izenda.Connect');
  var NameEditor = require('share/components/controls/NameEditor/Izenda.NameEditor');
  var DashboardConstants = require('logic/data/Izenda.DashboardConstants');
  var classnames = require('classnames');
  var RWNumberPicker = require('react-widgets').NumberPicker;
  var UserLookUp = require('modules/User/Izenda.UserLookUp');
  var CONSTANT = require('logic/data/Izenda.AccessConstants');
  var uiState = require('logic/Izenda.UiState');
  var Input = require('share/components/controls/Izenda.Input');
  var Label = require('share/components/controls/Izenda.Label');
  var action = require('./Izenda.DashboardDesignerHeaderAction');

  var observer = require('mobx-react').observer;
  const { isNil, get, omit } = require('lodash/fp');
  var GlobalDashBoard = observer(function(props) {
    var store = props.store;
    var isNewDashboard = isNil(get('id', props.store.dashboardDetail.dashboard));

    return (
      <div className={props.clsName + ' u_paddingTop'}>
        <Label>
          <Input
            className='u_marginRight'
            checked={store.dashboardDetail.dashboard.isGlobal}
            disabled={!isNewDashboard}
            type='checkbox'
            onChange={props.updateGlobalDashboardCheckbox}
          />
          {DashboardConstants.GLOBAL_DASHBOARD}
        </Label>
      </div>
    );
  });

  var DashboardDesignerHeader = function(props) {
    var localization = props.localization;
    /**
     * Exit slide show.
     */
    function exitSlideShow() {
      props.store.dashboardDesignerMode.togglePresentation();
    }

    /**
     * Show dashboard with fullscreen mode.
     */
    function fullscreen() {
      props.store.dashboardDesignerMode.toggleFullscreen();
    }

    /**
     * render left header component
     * @return {Object} left header component
     */
    function renderLeftHeader() {
      if (get('integrationStyle.hideDashboardName', props)) {
        return null;
      }

      var store = props.store;
      var model = store.model.dashboardDetail;
      var ownerValue = isNil(model.dashboard.ownerId)
        ? []
        : [
            {
              id: model.dashboard.ownerId,
              name: model.dashboard.owner
            }
          ];

      var clsName = classnames(' u_alignMiddle u_fullWidth u_paddingLeft u_marginTop', {
        'izenda-DashboardDesigner-Header-DashboarName': !isNil(props.dashboardDetail.dashboard.name)
      });

      var changeName = model.markDirty;
      var isGlobal = model.dashboard.isGlobal;

      var showGlobalCheckbox =
        (isNil(uiState.tenantId) && uiState.currentUser.systemAdmin) ||
        (model.dashboard.isGlobal && !isNil(model.dashboard.id));

      var dashboardNameCols = 6;
      // Technical Debt.
      if (showGlobalCheckbox) {
        dashboardNameCols = isGlobal ? 9 : 4;
      }

      if (store.dashboardDesignerMode.isAccess) {
        return (
          <GridLayout>
            <GridLayout.Row>
              <GridLayout.Col cols={dashboardNameCols} className='u_marginBottom'>
                <div className={clsName}>
                  <NameEditor
                    {...props}
                    store={store}
                    dataDetail={props.dashboardDetail.dashboard}
                    validationMessage={DashboardConstants.CONSTRAINTS.NAME}
                    changeName={changeName}
                    title={localization.getText('COMMON_TOOLTIP_RENAME')}
                  />
                </div>
              </GridLayout.Col>
              {showGlobalCheckbox && (
                <GridLayout.Col cols='3' className='u_marginBottom'>
                  <GlobalDashBoard {...props} clsName={clsName} />
                </GridLayout.Col>
              )}
              {!model.dashboard.isGlobal && (
                <GridLayout.Col cols={showGlobalCheckbox ? 5 : 6} className='u_marginBottom'>
                  <div className='form-horizontal'>
                    <div className='form-group u-bgWhite u_paddingInner u_noMarginAll'>
                      <GridLayout.Col cols='2' className='u_textRight'>
                        <label className='control-label'>{localization.getText('COMMON_LABEL_OWNER')}</label>
                      </GridLayout.Col>
                      <GridLayout.Col cols='10'>
                        <UserLookUp
                          usedCurrentUser
                          useSearchName
                          data={store.accessStore.users.peek()}
                          value={ownerValue}
                          usingPopup={true}
                          onChange={store.model.dashboardDetail.updateDashboardOwner.bind(store.model.dashboardDetail)}
                          onChangeFromPopup={store.model.dashboardDetail.updateDashboardOwner.bind(
                            store.model.dashboardDetail
                          )}
                          valueField='id'
                          textField='name'
                          singleUser
                          validations={CONSTANT.CONSTRAINTS.DASHBOARD_OWNER}
                          field='owner'
                          userModeType={CONSTANT.USER_ACCESS_MODE.ACCESS}
                          useEmailInOptions
                        />
                      </GridLayout.Col>
                    </div>
                  </div>
                </GridLayout.Col>
              )}
            </GridLayout.Row>
          </GridLayout>
        );
      }
      return (
        <div className='u_tableCell u_fullWidth'>
          <GridLayout>
            <GridLayout.Row>
              <GridLayout.Col cols={showGlobalCheckbox ? 9 : 12} className='u_marginBottom'>
                <div className={clsName}>
                  <NameEditor
                    {...props}
                    store={store}
                    dataDetail={props.dashboardDetail.dashboard}
                    validationMessage={DashboardConstants.CONSTRAINTS.NAME}
                    changeName={changeName}
                    title={localization.getText('COMMON_TOOLTIP_RENAME')}
                  />
                </div>
              </GridLayout.Col>
              {showGlobalCheckbox && (
                <GridLayout.Col cols='3' className='u_marginBottom'>
                  <GlobalDashBoard {...props} clsName={clsName} />
                </GridLayout.Col>
              )}
            </GridLayout.Row>
          </GridLayout>
        </div>
      );
    }

    /**
     * OnChange minute for fullscreen.
     */
    function onChangeMinute(minute) {
      props.store.model.updateAutoDurationMinute(minute || 0);
    }

    /**
     * OnChange second for fullscreen.
     */
    function onChangeSecond(second) {
      props.store.model.updateAutoDurationSecond(second || 0);
    }

    /**
     * render right header component
     * @return {Object} right header component
     */
    function renderRightHeader() {
      var model = props.store.model;

      if (!props.store.dashboardDesignerMode.isPresentation) {
        return null;
      }
      return (
        <div className='u_tableCell'>
          <div className='izenda-DashboardDesigner-Header-PresentControl u_paddingInner'>
            {!uiState.isMobile && (
              <span>
                <span>{localization.getText('DASHBOARD_LABEL_SHOW_NEXT_SLIDE_AFTER')}</span>
                <RWNumberPicker
                  min={0}
                  max={59}
                  defaultValue={0}
                  className='u_inlineBlock u_marginLeft izenda-PresentationBar-Button'
                  value={model.autoDurationMinute}
                  onChange={onChangeMinute}
                />
                <span>&nbsp;{localization.getText('COMMON_LABEL_MINS')}</span>
                <RWNumberPicker
                  min={0}
                  max={59}
                  className='u_inlineBlock u_marginLeft izenda-PresentationBar-Button'
                  defaultValue={0}
                  value={model.autoDurationSecond}
                  onChange={onChangeSecond}
                />
                <span>&nbsp;{localization.getText('COMMON_LABEL_SECS')}</span>
                <i
                  title={localization.getText('DASHBOARD_LABEL_FULLSCREEN_MODE')}
                  className='icon-fullscreen u_inlineBlock u_marginLeft selectable'
                  onClick={fullscreen}
                />
              </span>
            )}
            <i
              title={localization.getText('DASHBOARD_LABEL_EXIT_PRESENTATION_MODE')}
              className='icon-exit-slideshow u_inlineBlock u_marginLeft selectable'
              onClick={exitSlideShow}
            />
          </div>
        </div>
      );
    }

    function updateResults() {
      const { loader, store } = props;
      const clonedModel = clonedModel || {};

      loader.startLoading();

      return store
        .validateDashboard(clonedModel)
        .then(function(result) {
          if (result.success) {
            return store.updateUseCache(true).then(() => store.updateResults());
          } else {
            if (result.messages[0].detail) {
              return props.confirmFn('Information', {
                description: DashboardConstants.validateFilterMessage(result),
                type: 'error',
                isHTMLFormat: true,
                showCloseIndicator: true
              });
            } else {
              return props.validation.updateErrors(result.messages);
            }
          }
        })
        .finally(loader.endLoading.bind(loader));
    }
    return (
      <div className='izenda-DashboardDesigner-Header'>
        <div className='u_table u_fullWidth'>
          {renderLeftHeader()}
          {renderRightHeader()}
        </div>
      </div>
    );
  };

  DashboardDesignerHeader.propTypes = {
    store: React.PropTypes.object,
    dashboardDetail: React.PropTypes.object
  };

  module.exports = connect(action)(DashboardDesignerHeader);
})();



// WEBPACK FOOTER //
// ./ui/modules/Dashboard/DashboardDesigner/Izenda.DashboardDesignerHeader.jsx